module.exports = __webpack_public_path__ + "img/resinit-logo.21e35d54.svg";